'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424 from "./presto.-Dashboard-View$$anon$24.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024 from "./presto.types$-Dashboard-Sign-Stats$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$23() {
  this.aKH = null;
  this.aKz = null;
  this.aKA = false;
  this.aKI = null;
  this.aKJ = false;
  this.aKM = null;
  this.aKF = null;
  this.aKG = false;
  this.aKB = null;
  this.aKC = false;
  this.aKD = null;
  this.aKE = false;
  this.aKK = false;
  this.aKL = false;
  this.aKH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKM = "DashboardSignStats";
}
export { $c_Lpresto_DashboardView$$anon$23 as $c_Lpresto_DashboardView$$anon$23 };
$p = $c_Lpresto_DashboardView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$23;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$23() {
}
export { $h_Lpresto_DashboardView$$anon$23 as $h_Lpresto_DashboardView$$anon$23 };
$h_Lpresto_DashboardView$$anon$23.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aKH;
});
$p.L = (function() {
  if ((!this.aKA)) {
    this.aKz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKA = true;
  }
  return this.aKz;
});
$p.O = (function() {
  if ((!this.aKJ)) {
    this.aKI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKJ = true;
  }
  return this.aKI;
});
$p.E = (function() {
  return this.aKM;
});
$p.t = (function() {
  if ((!this.aKG)) {
    this.aKF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("signatures", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("envelopes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aKG = true;
  }
  return this.aKF;
});
$p.M = (function() {
  if ((!this.aKC)) {
    this.aKB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aKC = true;
  }
  return this.aKB;
});
$p.Q = (function() {
  if ((!this.aKE)) {
    this.aKD = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424.$c_Lpresto_DashboardView$$anon$24();
    this.aKE = true;
  }
  return this.aKD;
});
$p.w = (function() {
  if ((!this.aKL)) {
    this.aKK = false;
    this.aKL = true;
  }
  return this.aKK;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee124) => ((p) => \u03b4scrutinee124.cGw(p)))($j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024.$m_Lpresto_types$DashboardSignStats$())));
});
var $d_Lpresto_DashboardView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$23, "presto.DashboardView$$anon$23", ({
  GP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$23 as $d_Lpresto_DashboardView$$anon$23 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$23.js.map
